import { render } from "./PriceListTargetDialog.vue?vue&type=template&id=1fbaf35a"
import script from "./PriceListTargetDialog.vue?vue&type=script&lang=js"
export * from "./PriceListTargetDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__